<router-outlet></router-outlet>
<div id="divPageLoader" name="divPageLoader" class="ui-web-fullpage-loader">
    <div class="ui-web-fullpage-loader__message">{{ getMessages() }}</div>
</div>
<div id="divDRCTPaymentWidget" name="divDRCTPaymentWidget" class="divPayment container-fluid">
    <div class="container divPayment--container">
        <div class="row divPayment--row">
            <div class="divPayment--col col-12 col-xl-6">
                <div class="divPayment--header">
                    <img [src]="env.assetsPath + '/img/drct-logo.png'" alt="Divine Retreat Centre, Toronto" class="light-logo">
                </div>
                <button type="button" id="btnPaymentClose" name="btnPaymentClose" class="btn-close" title="Close" aria-label="Close" (click)="onPaymentWindowClose()"></button>
                <div id="divMonerisCheckout" name="divMonerisCheckout" class="divMonerisCheckout"></div>
            </div>
        </div>
    </div>
</div>